import { useDataTable } from '@/components/data-table/data-table-provider'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from '@/components/ui/accordion'
import * as React from 'react'
import { DataTableFilterCheckbox } from './data-table-filter-checkbox'
import { DataTableFilterCheckboxCompact } from './data-table-filter-checkbox-compact'
import { DataTableFilterInput } from './data-table-filter-input'
import { DataTableFilterResetButton } from './data-table-filter-reset-button'
import { DataTableFilterSlider } from './data-table-filter-slider'
import { DataTableFilterTimerange } from './data-table-filter-timerange'

// FIXME: use @container (especially for the slider element) to restructure elements

// TODO: only pass the columns to generate the filters!
// https://tanstack.com/table/v8/docs/framework/react/examples/filters

// Pluggable filter registry — extend by adding entries
export const FILTER_COMPONENTS: Record<string, React.ComponentType<any>> = {
  checkbox: DataTableFilterCheckbox,
  input: DataTableFilterInput,
  slider: DataTableFilterSlider,
  timerange: DataTableFilterTimerange,
}

export function DataTableFilterControls() {
  const { filterFields } = useDataTable()
  const [isMounted, setIsMounted] = React.useState(false)

  React.useEffect(() => {
    const timer = setTimeout(() => setIsMounted(true), 0)
    return () => clearTimeout(timer)
  }, [])

  // v3 design: sections are always open. The accordion is kept (rather than
  // ripped out) so existing show/hide animation chrome and Radix item
  // semantics stay in place, but the per-section trigger is replaced with a
  // static header — `value` is bound to every field so the accordion is
  // permanently expanded with no toggle UI.
  return (
    <Accordion
      type="multiple"
      className={
        isMounted
          ? undefined
          : '[&_[data-slot=accordion-content]]:!animate-none'
      }
      value={filterFields?.map(({ value }) => value as string) ?? []}>
      {filterFields?.map((field, index) => {
        const value = field.value as string
        const groupHeading =
          field.group && filterFields[index - 1]?.group !== field.group
            ? field.group
            : null
        const isCompactCheckbox =
          field.type === 'checkbox' && field.compact === true
        const FilterComponent = isCompactCheckbox
          ? DataTableFilterCheckboxCompact
          : FILTER_COMPONENTS[field.type]
        if (!FilterComponent) return null
        return (
          <AccordionItem key={value} value={value} className="border-none">
            {groupHeading && (
              <p className="text-muted-foreground border-neutral-subtle-border mt-3 border-t px-1 pt-4 text-xs font-medium tracking-wide uppercase">
                {groupHeading}
              </p>
            )}
            <div className="flex w-full items-baseline justify-between gap-2 truncate px-1 pt-3 pb-2">
              <p className="text-primary-high-contrast min-w-0 truncate text-sm font-semibold">
                {field.label}
              </p>
              <div className="flex items-center gap-2">
                <DataTableFilterResetButton {...field} />
              </div>
            </div>
            <AccordionContent>
              {/* REMINDER: avoid the focus state to be cut due to overflow-hidden */}
              {/* REMINDER: need to move within here because of accordion height animation */}
              <div className="px-1 pb-1">
                <FilterComponent {...field} />
              </div>
            </AccordionContent>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
